import type {DiffLineType} from '@github-ui/diffs/types'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'
import {memo} from 'react'

// the actual diff line text itself needs to be memoized because otherwise when the parent re-renders, any
// selections (either from click dragging selection or from control+f highlighting) will be lost
export const LineTextWrapper = memo(function LineTextWrapperComponent({
  lineHtml,
  lineType,
  lineTypeCharacter,
}: {
  lineHtml: string
  lineType: DiffLineType
  lineTypeCharacter: string | undefined
}) {
  return (
    <code
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className={clsx('diff-text syntax-highlighted-line', {
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        addition: lineType === 'ADDITION',
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        deletion: lineType === 'DELETION',
      })}
    >
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      {lineTypeCharacter && <span className="diff-text-marker">{lineTypeCharacter}</span>}
      <VerifiedHTMLDiv
        // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- HTML is sanitized server-side. TODO: Move type assertion to data ingress point.
        html={lineHtml as SafeHTMLString}
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        className="diff-text-inner"
      />
    </code>
  )
})
